import { render, staticRenderFns } from "./UserChildAccount.vue?vue&type=template&id=28d430fc&scoped=true&"
import script from "./UserChildAccount.vue?vue&type=script&lang=js&"
export * from "./UserChildAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserChildAccount.vue?vue&type=style&index=0&id=28d430fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d430fc",
  null
  
)

export default component.exports